<template>
  <v-row>
    <v-col cols="auto" class="pb-0">
      <h6>{{ title }}</h6>
    </v-col>
    <v-col cols="12">
      <v-treeview
        :items="formattedData"
        item-text="message"
        item-key="id"
        color="primary"
        :load-children="fetchChildren"
        hoverable
        transition
        rounded
        dense
      >
        <template v-slot:prepend="{ open }">
          <v-icon>
            {{ open ? "mdi-folder-open-outline" : "mdi-folder-outline" }}
          </v-icon>
        </template>
        <template v-slot:label="{ item }">{{ item.message }}</template>
        <template v-slot:append="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon @click="editItem(item)"> mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span> Actualizar </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="item[keyToDisabledAdd] || !item.sub_menu"
                icon
                v-on="on"
              >
                <v-icon @click="registerChildren(item)">mdi-plus-circle</v-icon>
              </v-btn>
            </template>
            <span>Agregar</span>
          </v-tooltip>
          <v-tooltip
            v-if="
              item.hasOwnProperty('children') == false || item.children == 0
            "
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon @click="deleteItem(item)">mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-treeview>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    title: { type: String },
    keyToDisabledAdd: { type: String },
    data: { type: Array },
    loadChildren: { type: Function },
    submit: { type: Function },
  },
  data() {
    return {
      isOpenForm: false,
      selectedItem: {},
      formattedData: this.formatData(
        this.data.map((el) => ({ ...el, children: [] }))
      ),
      // formattedData: JSON.parse(JSON.stringify(generateFormattedData(this.data))),
    };
  },

  watch: {
    data(val) {
      // this.formattedData = JSON.parse(JSON.stringify(generateFormattedData(val)));
      this.formattedData = this.formatData(val);
    },
  },

  methods: {
    formatData(options) {
      return JSON.parse(JSON.stringify(options));
    },

    async fetchChildren(item) {
      await this.loadChildren(item);
    },

    editItem(item) {
      this.$emit("item:edit", item, true);
    },

    registerChildren(item) {
      this.$emit("item:createChild", item);
    },

    deleteItem(item) {
      this.$emit("item:delete", item);
    },
  },
};
</script>
